/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';

export const actions = {
  async detail({}) {
    const url = `/profil`;
    return await http.get(url).then(({ data }) => data);
  },

  async update({}, params) {
    return http.patch(`/profil`, params).then(({ data }) => data);
  },

  async password({}, params) {
    return http.post(`/profil/password`, params).then(({ data }) => data);
  },
};
